import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 26,
	viewBox: "0 0 25 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.5,
			cy: 13,
			r: 12,
			stroke: "#003B6F"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_13741_27026)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M6.25 16.645C6.25 14.4583 6.25 12.2687 6.25 10.082C6.32024 9.87646 6.5157 9.81092 6.69894 9.94498C6.91577 10.0999 7.11123 10.2786 7.31585 10.4484C7.93581 10.9668 8.55882 11.4792 9.18184 11.9976C9.80791 12.5189 10.434 13.0432 11.057 13.5705C11.3044 13.7821 11.5517 13.9936 11.8022 14.2021C12.2267 14.5507 12.7581 14.5566 13.1795 14.2021C13.8453 13.645 14.5019 13.079 15.1707 12.5249C15.806 11.9946 16.4443 11.4673 17.0825 10.937C17.4399 10.6391 17.8033 10.3442 18.1575 10.0433C18.2553 9.95987 18.353 9.87646 18.4996 9.88837C18.6401 9.90029 18.7256 9.97477 18.7409 10.1088C18.747 10.1476 18.7439 10.1893 18.7439 10.228C18.7439 12.3163 18.7348 14.4047 18.75 16.493C18.7561 17.1723 18.2186 17.5893 17.6231 17.5893C14.8317 17.5834 12.0404 17.5864 9.24903 17.5864C8.60769 17.5864 7.96635 17.5923 7.32195 17.5834C6.87607 17.5774 6.53708 17.3838 6.32635 16.9935C6.26832 16.8803 6.27443 16.7611 6.25 16.645Z",
				fill: "#003B6F"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M12.4962 8.4165C14.2095 8.4165 15.9258 8.4165 17.6391 8.4165C17.9598 8.4165 18.2346 8.51779 18.4545 8.75016C18.6072 8.91103 18.598 9.05403 18.424 9.19703C17.0985 10.2993 15.77 11.3986 14.4446 12.5038C13.9285 12.9328 13.4185 13.3707 12.9085 13.8057C12.6031 14.0649 12.374 14.0649 12.0717 13.8057C10.2606 12.2506 8.41297 10.7402 6.57752 9.21192C6.37901 9.04509 6.36985 8.90508 6.55309 8.72335C6.76993 8.50886 7.03562 8.4165 7.34102 8.4165C9.06042 8.41948 10.7798 8.4165 12.4962 8.4165Z",
				fill: "#003B6F"
			})]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6.75,
			y: 8.9165,
			width: 11.5,
			height: 8.16667,
			rx: 1.5,
			stroke: "#003B6F"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_13741_27026",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 6.25,
				y: 8.4165,
				width: 12.5,
				height: 9.16667,
				rx: 2,
				fill: "white"
			})
		}) })
	]
});
export default SvgEmail;
